module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAYCAYAAAAVibZIAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADDSURBVDiN5ZTNDQIhEEYfLJ61hLWDLcEStAM52oVdbGJMOFgAJdgCHWgJ3hfRi4mKJEqEg/E7wfDxZjL8CCIZYydnxR44DR690otjrkfGG3wTlkAHzFQT5vH6J54XqBRynBrneMTG2E4qzC3zt3LBo2VBIEAnFUYWBN7BhYEAKAHrGuDiEtudvZSGVulpnYN6nAyeafyOe2PbkeKQA32qNPV5pGJZ0FL6UWhvbBsbUrF3+vPLXw3qCjOdDB5dEOyCR18B/K5ANpkrXXwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/notice_day.png
// module id = x6bn
// module chunks = 1